<template>
  <slot name="beforeList" />
  <div class="OverviewListItem flex">
    <div class="event-info-container flex relative align-start">
      <div class="col-1-3 sm-col-1-1 sm-mb-lg">
        <BaseImage
          :media-object="event.image1"
          class="event-image"
        />
      </div>
      <div class="col-2-3 sm-col-1-1 no-p flex flex-nowrap h-full sm-flex-column">
        <div class="content flex flex-column sm-col-1-1">
          <ul class="no-bullets flex align-center">
            <li
              v-if="event.genres?.length"
              class="label mr-md"
            >
              {{ event.genres.map((genre: EventGenre) => genre.name).join(' & ') }}
            </li>
            <li>{{ getEventItemDate(event) }}</li>
          </ul>
          <h3 class="event-title">
            <UILinkComponent
              :to="event.url"
              class="no-underline covering-link"
              @click="trackSelectItem({ items: [eventToGA4Item(event)] })"
            >
              {{ event.title }}
            </UILinkComponent>
          </h3>
          <p class="event-oneliner sm-mb-md">
            {{ event.oneLiner }}
          </p>
        </div>
        <div class="sm-col-1-1 btn-container flex h-full align-end sm-align-start">
          <span
            class="btn btn-secondary btn-hover-animation"
            aria-hidden="true"
          >
            <span class="btn-title-wrap">
              <span class="btn-title btn-title--out">
                <span
                  v-for="(word, index) in ticketButtonWords"
                  :key="index"
                  class="btn-title-word"
                  :style="{ transitionDelay: `${index * 30}ms` }"
                >
                  {{ word }}&nbsp;
                </span>
              </span>
              <span class="btn-title btn-title--in">
                <span
                  v-for="(word, index) in ticketButtonWords"
                  :key="index"
                  class="btn-title-word"
                  :style="{ transitionDelay: `${index * 30}ms` }"
                >
                  {{ word }}&nbsp;
                </span>
              </span>
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { EventGenre } from '@tc8l/nuxt-overview'

  defineProps<{
    event: EventItem
  }>()

  const { trackSelectItem } = useTracking()
  const { getEventItemDate } = useEventDate()

  const ticketButtonWords = ['Meer', 'informatie']
</script>

<style lang="scss" scoped>
  .OverviewListItem {
    width: 100%;
  }

  .event-info-container {
    width: 100%;
  }

  :deep(.image-wrapper),
  :deep(.event-image) {
    width: 100%;
    height: 24rem;
    position: relative;
    border-radius: var(--border-radius-lg);
    overflow: hidden;

    picture,
    img {
      width: 100%;
    }
  }

  :deep(.event-image) img {
    width: 100%;
    object-fit: cover;
    height: 100%;
    position: relative;
    transition: transform var(--animation-duration) var(--ease-fast-in-slow-out);
  }

  .event-info-container:hover :deep(.event-image) img {
    transform: scale(1.03);
  }

  .event-info-container:hover .btn-title-word {
    transform: translateY(-100%);
  }

  .content {
    min-width: 0;
    flex-grow: 1;
    gap: var(--margin-md);

    ul {
      row-gap: 1.6rem;
    }
  }

  .event-title,
  .event-oneliner {
    overflow: hidden;
    @include line-clamp(2);
  }

  .btn-container {
    flex-shrink: 0;
  }
</style>
